<template>
  <div>
    <van-popup v-model="show" position="right" style="width:100%;height:100%;">
      <div class="bg-white popup-box">
        <section class="container-footer">
          <div class="popup-del flex all-c" >
            <span class="icon icon-chacha f18" @click="show=false"></span><span class="flex-1 txt-c f20 pr16">班次要求</span>
          </div>
          <div class="home-per">
            <div class="ds-partime-list flex f-wrap">
              <p class="van-bor1 van-hairline--surround" :class="{'selected':workTimeTypeList.indexOf(key)>-1}"
                  v-for="(item,key) in workTimes" :key="item"
                  @click="onCheck(key,'workTimeTypeList')">
                <span class="block txt-elips">{{item}}</span>
              </p>
            </div>
          </div>
        </section>
        <footer class="footer-fixed flex all-c">
          <van-button block type="default" class="flex-1 radius-0" @click="clear">
            <span class="f16 c-orange">重置</span>
          </van-button>
          <van-button block type="primary" class="flex-1 btn-gradient radius-0" @click="search">
            <span class="f16">确定</span>
          </van-button>
        </footer>
      </div>
    </van-popup>
  </div>
</template>

<script>

  const { areaList, WorkTimeType, ExperienceAge, PositionTypes, GenderTypes, AgeType } = require('../../../libs/config');

  export default {
    data() {
      return {
        show: false,
        areaList: areaList.filter(v => v !== '任意区域'),
        workTimes: WorkTimeType,
        experiences: ExperienceAge,
        positionTypes: PositionTypes,
        genderTypes: GenderTypes,
        ageType: AgeType,
        showFilter: false,
        activeNames: ['0', '1', '2', '3', '4', '5', '6'],
        cateList: [],
        tagClassNameList: [],
        contractAddressList: [],
        positionTypeList: [],
        experienceList: [],
        workTimeTypeList: [],
        positionClassSysNoList: [],
        positionTagClassNameList: [],
        ageList: [],
        userGenderList: []
      };
    },
    mounted() {
    },
    methods: {
      onCheck(item, key) {
        const index = this[key].indexOf(item);
        if (index > -1) {
          this[key].splice(index, 1);
        } else {
          this[key].push(item);
        }
      },
      clear() {
        this.positionTypeList = [];
        this.positionClassSysNoList = [];
        this.positionTagClassNameList = [];
        this.workTimeTypeList = [];
      },
      search() {
        // let ageList = this.workTimeTypeList.map(item => {
        //   return this.workTimes[item];
        // });
        let showTimeTip = '';
        for (let index = 0; index < 4; index++) {
          if (this.workTimeTypeList.indexOf(index + '') >= 0) {
            showTimeTip += this.workTimes[index] + ',';
          }
        }
        if (showTimeTip.length > 0) {
          showTimeTip = showTimeTip.substring(0, showTimeTip.length - 1);
          if (showTimeTip.length > 3) {
            showTimeTip = showTimeTip.substring(0, 2) + '..';
          }
        }
        // shiftType: 班次 0-早班 1-中班 2-晚班 3-其他
        this.$emit('search', {
          shiftType: this.workTimeTypeList.length ? this.workTimeTypeList.map(Number) : [],
          ShowTimeTip: showTimeTip
        });
        this.show = false;
      },
      setWelfare(arr) {
        this.tagClassNameList = [...arr]; // 显示用
        this.positionTagClassNameList = [...arr];
      }
    }
  };
</script>

<style lang="less" scoped>
  @import '../../../assets/css/theme.less';
  .popup-del{ padding: 10px 0 5px 15px;}
  .drawline {
    height: 1px;
    width: 100%;
  }

  .ds-partime-list {
    margin: 30px 20px;
  }
  .ds-partime-list p{
    width: 31.5%;
    margin: 0 2.75% 10px 0;
    box-sizing: border-box;
    height:35px;
    line-height:36px;
    font-size: 14px;
  }
  .ds-partime-list p:nth-child(3n+3){
    margin: 0;
  }

  .fringe .van-cell__value--alone {
    color: #666;
  }

  .van-hairline--top-bottom::after {
    border-width: 0;
  }
</style>
